module.exports = __webpack_public_path__ + "dist/img/qq.89eb5e1a.svg";